module.exports = __webpack_public_path__ + "static/media/background.88551958.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/background.png
 ** module id = 665
 ** module chunks = 0
 **/